import { TextField } from '@mui/material'
import CustomDialog from '../CustomDialog'
import { useDispatch } from 'react-redux'
import { addClientAsync } from '../../services/clientsService'
import { Client } from '../../models/Organization'
import DisplayErrorPopup from '../DisplayError'
import { Can } from '../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'

const AddClient = (props: any) => {
  const dispatch = useDispatch<any>()
  const { isOpen, handleClose, organization_id } = props
  const handleSubmit = (client: Client) => {
    client.organization_id = organization_id
    dispatch(addClientAsync(client))
  }

  return (
    <Can I={AttributeActionNames.Create} a={AttributeResourceNames.Clients}>
      <CustomDialog
        isOpen={isOpen}
        title='Create a new client'
        handleClose={handleClose}
        handleSubmit={handleSubmit}
      >
        <DisplayErrorPopup />
        <TextField
          sx={{
            width: '389px',
            '& .MuiInputBase-input': {
              color: '#04002E',
              fontSize: '14px',
              lineHeight: 'normal',
            },
            '& .MuiOutlinedInput-root': {
              boxShadow: '0px 3px 10px 0px rgba(187, 187, 187, 0.25)',
            },
            '& .MuiInputBase-input::placeholder': {
              color: '#C3C3C3',
              opacity: 1,
              fontSize: '14px',
            },
          }}
          size='small'
          placeholder='Add client name'
          autoFocus
          required
          margin='dense'
          id='name'
          name='name'
        />
      </CustomDialog>
    </Can>
  )
}

export default AddClient
